import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
export function Splash() {
    const { user, loading } = useAuth();
    const nav = useNavigate();
    useEffect(() => {
        if (loading)
            return;
        if (user)
            nav('/orgs', { replace: true });
        else
            nav('/login', { replace: true });
    }, [user, loading, nav]);
    return (_jsxs("div", { className: "splash", children: [_jsx("div", { className: "ring" }), _jsx("div", { className: "step", children: _jsx("div", { className: "title", children: "Loading FDN..." }) })] }));
}
